export const enum WordPluralType {
  // eslint-disable-next-line no-unused-vars
  MONTH = 'month',
  // eslint-disable-next-line no-unused-vars
  DAY = 'day',
  // eslint-disable-next-line no-unused-vars
  WEEK = 'week',
}

const wordsObj: Record<string, { one: string; some: string; lot: string }> = {
  [WordPluralType.MONTH]: {
    one: 'месяц',
    some: 'месяца',
    lot: 'месяцев',
  },
  [WordPluralType.DAY]: {
    one: 'день',
    some: 'дня',
    lot: 'дней',
  },
  [WordPluralType.WEEK]: {
    one: 'неделя',
    some: 'недели',
    lot: 'недель',
  },
};

interface IProps {
  count: number;
  type: keyof typeof wordsObj;
}

export const getWordPlural = ({ count, type = 'month' }: IProps): string => {
  const lastDigit = count % 10;
  const lastTwoDigits = count % 100;

  if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
    return `${count} ${wordsObj[type].lot}`;
  }

  if (lastDigit === 1) {
    return `${count} ${wordsObj[type].one}`;
  }

  if (lastDigit >= 2 && lastDigit <= 4) {
    return `${count} ${wordsObj[type].some}`;
  }

  return `${count} ${wordsObj[type].lot}`;
};
